import { BarChart, Bar, Tooltip, Cell, ResponsiveContainer } from 'recharts'
import { CHART_TOOLTIP_STYLE, ChartGrid, ChartXAxis, ChartYAxis } from '../chart-primitives'
import { formatNumber } from '../../../format'

interface Props {
 data: Array<{ day: string; count: number }>
 /** ResponsiveContainer height — a px number, or "100%" to fill a sized parent. */
 height?: number | `${number}%`
}

// Title-less by design: the enclosing card owns the heading (via `SectionTitle`),
// matching its sibling charts (PeakHoursChart, UsageOverTimeChart). Rendering an
// internal heading here duplicated the card title. See the activity page.
export function DayOfWeekChart({ data, height = 140 }: Props) {
 const max = Math.max(...data.map((d) => d.count), 1)
 return (
  <ResponsiveContainer width="100%" height={height}>
   <BarChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: 0 }}>
     <ChartGrid vertical={false} />
     <ChartXAxis dataKey="day" />
     <ChartYAxis width={28} />
     <Tooltip
      contentStyle={CHART_TOOLTIP_STYLE}
      formatter={(val) => [formatNumber(typeof val === 'number' ? val : 0), 'messages']}
     />
     <Bar dataKey="count" radius={[3, 3, 0, 0]} isAnimationActive={false}>
      {data.map((d, i) => (
       <Cell
        key={i}
        fill="var(--chart-1)"
        fillOpacity={d.count === max ? 1 : d.count > max * 0.6 ? 0.66 : 0.25}
       />
      ))}
     </Bar>
    </BarChart>
  </ResponsiveContainer>
 )
}
